import styled from 'styled-components';

import {colors, font, border, breakpoint} from 'theme';

export const Root = styled.form`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const Grid = styled.div<{columns: string}>`
    display: grid;
    grid-template-columns: ${(p) => p.columns};
    grid-auto-rows: auto;
    gap: 10px;
    width: 100%;
    height: 100%;
    @media (max-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr;
    }
`;

export const Headline = styled.div`
    margin-bottom: 10px;
    padding-left: 2px;
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
`;
export const GridRow = styled.div<{columnSpan?: string}>`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 10vw;
    ${(p) => (p.columnSpan ? `grid-column: span ${p.columnSpan}` : '')};
`;

export const AddLineButton = styled.button`
    padding: 10px 24px;
    border-radius: ${border.radius};
    background-color: ${colors.brandLight};
    border: 0;
    outline: 0;

    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 2%;
    color: ${colors.brandPrimary};
`;

export const LableContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-contetn: flex-start;
    gap: 5px;
`;

export const Label = styled.div`
    color: #8a8a8a;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
`;

export const CalcDisplay = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    height: 50px;
    background-color: ${colors.lightGrey};
    border-radius: ${border.radius};
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
`;
export const Hr = styled.hr`
    width: 100%;
    height: 1px;
    border: 0;
    background: #ebebeb;
    grid-column: 1/-1;
`;
